import React, { FC, ReactNode } from 'react';
import { Theme } from '../../types';
import ThemeContext from './ThemeContext';

type Props = {
  children: ReactNode;
  theme: Theme;
};

const ThemeProvider: FC<Props> = ({ children, theme }): JSX.Element => (
  <ThemeContext.Provider
    value={{
      theme
    }}
  >
    {children}
  </ThemeContext.Provider>
);

export default ThemeProvider;
